import type { ZuubOnboardingBeginResponse } from '@/@types/zuub/contracts';

import { CredentialsFailedError } from '../CredentialsFailedError';
import { VideaUserInformationForm } from '../VideaUserInformationForm';
import { VideaUserInformationFormSkeleton } from '../VideaUserInformationFormSkeleton';

interface ConnectionFormProps {
  onboardingResponse?: ZuubOnboardingBeginResponse | null;
  onboardingError?: Error | null;
  isLoadingOnboarding: boolean;
  localPassword: string;
  onSave: (password: string) => void;
  isSaving: boolean;
}

export const ConnectionForm = ({
  onboardingResponse,
  onboardingError,
  isLoadingOnboarding,
  localPassword,
  onSave,
  isSaving,
}: ConnectionFormProps) => {
  const hasError = onboardingError !== null;

  return (
    <div className="vai-w-[55%]">
      <div className="vai-flex-1 vai-bg-zinc-50 vai-border vai-border-gray-300 vai-rounded-lg vai-p-6 vai-min-h-[500px]">
        {hasError ? (
          <CredentialsFailedError />
        ) : isLoadingOnboarding ? (
          <VideaUserInformationFormSkeleton />
        ) : (
          <div className="vai-min-h-[400px] vai-flex vai-flex-col">
            <VideaUserInformationForm
              onboardingData={onboardingResponse || undefined}
              localPassword={localPassword}
              onSave={onSave}
              isSaving={isSaving}
            />
          </div>
        )}
      </div>
    </div>
  );
};
